import React, { Component } from 'react';

import './Slider.css';

class Slide extends Component {
  render() {
    return(
      <div className={`slider_wrapper ${this.props.number === this.props.current ? 'visible' : ''}`}>
        <div className='icon'>
          <img src={this.props.img} alt='' />
        </div>
        <h1>{this.props.title}</h1>
        <p>{this.props.children}</p>
      </div>
    )
  }
}

export default Slide;



// WEBPACK FOOTER //
// ./src/components/Slider.jsx